import React from 'react';

import Button, { ButtonProps } from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  loading: {
    marginRight: theme.spacing(1),
  },
}));

interface SubmitBtnProps extends ButtonProps {
  title: string;
  isSubmitting?: boolean;
}

export const SubmitBtn = ({
  type = 'submit',
  title,
  isSubmitting = false,
  ...props
}: SubmitBtnProps) => {
  const classes = useStyles();
  return (
    <Button {...props} type={type} >
      {isSubmitting && <CircularProgress size={20} color="inherit" className={classes.loading} />}
      {title}
    </Button>
  );
};

export default SubmitBtn;
